import script from "./DocumentCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentCard.vue?vue&type=style&index=0&id=2e1083ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1083ba"]])

export default __exports__